const addNew = (list, data) => {
  list.unshift(data);
  return list;
};

const update = (list, data) => list.map((item) => {
  if (item.trip_id === data.trip_id) {
    return data;
  }
  return item;
});

const mutation = {
  SET_TRACK_PAGE(state, data) {
    state.tripFilter.page = data;
  },
  SET_TRIP_ALL(state, data) {
    const result = (state.tripFilter.page > 1) ? state.trips.concat(data) : data;
    state.trips = result;
    if (data.length) {
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
  },
  SET_TRIP_LOADING_LIST_STATUS(state, data) {
    state.trackLoadingStatus = data;
  },
  TRACK_FORM_LOAD(state, data) {
    state.trackFormLoading = data;
  },
  SET_TRIP_PAGINATION(state, data) {
    state.tripPagination = data;
  },
  APPEND_NEW_TRIP(state, { data }) {
    state.trips = addNew(state.trips, data);
  },
  SET_TRIP_SHOW_LOADING(state, status) {
    state.showLoading = status;
  },
  TRIP_DETAILS(state, { data }) {
    state.tripDetails = data;
  },
  UPDATE_EXISTING(state, { data }) {
    const result = update(state.trips, data);
    state.trips = result;
  },
  SET_TRIP_FORM_LOADING(state, status) {
    state.trackFormLoading = status;
  },
  SET_TRACK_META(state, data) {
    state.trackMeta = data;
  },
};

export default mutation;
